<div class="wizard-icon">
  <brt-icon [icon]="'chart'"></brt-icon>
</div>
